import React, { useEffect, useState } from 'react'
import LoginAirbnb from './LoginAirbnb'
import { useLocation } from 'react-use'
import { useDispatch, useSelector } from 'react-redux'
import { integrateAirbnbAccount, setAirbnbTab } from '../../actions/airbnb'
import {
  getAirbnbChecked,
  getAirbnbListings,
  getAirbnbStatus,
  getAirbnbSync,
  getAirbnbTab,
} from '../../reducers/airbnb/selectors'
import { IntegrationStatus, IntegrationSync } from '../../reducers/airbnb'
import ConnectListings from './ConnectListings'
import { withRouter } from 'react-router'
import LeaveModal from './Modals/LeaveModal'
import { isAllInOneLicenseValid } from '../../reducers/userAccount/selectors/license'
import { IStore } from '../../reducers'
import SplitScreen from './SplitScreen'
import Help from './Help'
import AirbnbHeader from './AirbnbHeader'

function IntegrationAirbnb({ mobile, setDisableCheck, history }: any) {
  const dispatch = useDispatch()
  const location = useLocation()
  const isPremium = useSelector(isAllInOneLicenseValid)
  const isLicenseLoading = useSelector(
    (state: IStore) => state.userAccount.license.isLoading,
  )
  const status = useSelector(getAirbnbStatus)
  const checked = useSelector(getAirbnbChecked)
  const tab = useSelector(getAirbnbTab)
  const listings = useSelector(getAirbnbListings)
  const sync = useSelector(getAirbnbSync)
  const [open, setOpen] = useState(false)
  const someConnected = listings.some(l => !!l.bedbooking_id_room)
  const [pathname, setPathname] = useState('/')

  useEffect(() => {
    const params = new URLSearchParams(location.search)
    if (params.get('code')) {
      dispatch(integrateAirbnbAccount({ code: params.get('code') }))
    }
  }, [location, checked, status, dispatch])

  // const onSelectTab = index => {
  //   if (status === IntegrationStatus.NotIntegrated) {
  //     return
  //   }
  //
  //   if (index === 2 && listings.length === 0) {
  //     return
  //   }
  //
  //   if (index === 2 && !someConnected) {
  //     return
  //   }
  //
  //   if (
  //     index === 2 &&
  //     !notEveryConnected &&
  //     sync === IntegrationSync.NotSyncing
  //   ) {
  //     dispatch(toggleAirbnbNotAllModal(true))
  //     return
  //   }
  //
  //   if (status === IntegrationStatus.Integrated && index === 0) {
  //     dispatch(setAirbnbTab(1))
  //   } else {
  //     if (index === 1 && tab === 2 && sync === IntegrationSync.NotSyncing) {
  //       setOpen(true)
  //       setPathname('tab1')
  //     } else {
  //       dispatch(setAirbnbTab(index))
  //     }
  //   }
  // }

  useEffect(() => {
    if (tab === 0 && status === IntegrationStatus.Integrated) {
      dispatch(setAirbnbTab(1))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tab, status])

  const unblock = history.block(tx => {
    if (
      tx.pathname === '/integration/room' ||
      location.pathname === '/integration/room'
    ) {
      unblock()
      return true
    }
    if (!someConnected && sync === IntegrationSync.Syncing) {
      if (tx.pathname.includes('airbnb-info')) {
        return true
      }
      setPathname(tx.pathname)
      setOpen(true)
      return false
    }
    unblock()
    return true
  })

  useEffect(() => {
    return () => {
      if (unblock) {
        unblock()
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const closeModal = () => {
    if (unblock) {
      unblock()
    }
    setOpen(false)
    if (pathname === 'tab1' || pathname.includes('airbnb-info')) {
      dispatch(setAirbnbTab(1))
    } else {
      history.push(pathname)
    }
  }

  const action = () => {
    setOpen(false)
  }

  useEffect(() => {
    if (!isPremium && !isLicenseLoading) {
      if (unblock) {
        unblock()
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isPremium, isLicenseLoading])

  return (
    <div>
      <LeaveModal open={open} handleClose={closeModal} action={action} />
      <SplitScreen
        mobile={mobile}
        Header={AirbnbHeader}
        LComp={
          tab === 0 ? (
            <LoginAirbnb />
          ) : (
            <ConnectListings mobile={mobile} unblock={unblock} />
          )
        }
        tab={tab}
        RComp={Help}
      />

      {/*<CustomizedSteppers />*/}
      {/*<BBTabs*/}
      {/*  selectedIndex={tab}*/}
      {/*  onSelect={onSelectTab}*/}
      {/*  defaultIndex={0}*/}
      {/*  forceRenderTabPanel={true}*/}
      {/*>*/}
      {/*  <BBTabList style={{ fontSize: `${16 * size}px` }}>*/}
      {/*    <BBTab*/}
      {/*      style={*/}
      {/*        checked && status === IntegrationStatus.Integrated*/}
      {/*          ? {*/}
      {/*              padding: '0px 15px',*/}
      {/*              paddingBottom: '12px',*/}
      {/*              wordBreak: 'break-word',*/}
      {/*              whiteSpace: 'pre-wrap',*/}
      {/*              color: '#bababa',*/}
      {/*              cursor: 'not-allowed',*/}
      {/*            }*/}
      {/*          : {*/}
      {/*              padding: '0px 15px',*/}
      {/*              whiteSpace: 'pre-wrap',*/}
      {/*              paddingBottom: '12px',*/}
      {/*              wordBreak: 'break-word',*/}
      {/*            }*/}
      {/*      }*/}
      {/*    >*/}
      {/*      <span style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>*/}
      {/*        {t('BBO_3914_password_recovery_text_4_login')}*/}
      {/*      </span>*/}
      {/*    </BBTab>*/}

      {/*    <BBTab*/}
      {/*      style={*/}
      {/*        status === IntegrationStatus.NotIntegrated*/}
      {/*          ? {*/}
      {/*              padding: '0px 15px',*/}
      {/*              paddingBottom: '12px',*/}
      {/*              whiteSpace: 'pre-wrap',*/}
      {/*              wordBreak: 'break-word',*/}
      {/*              color: '#bababa',*/}
      {/*              cursor: 'not-allowed',*/}
      {/*            }*/}
      {/*          : {*/}
      {/*              padding: '0px 15px',*/}
      {/*              paddingBottom: '12px',*/}
      {/*              whiteSpace: 'pre-wrap',*/}
      {/*              wordBreak: 'break-word',*/}
      {/*            }*/}
      {/*      }*/}
      {/*    >*/}
      {/*      <span style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>*/}
      {/*        {t('OUT_21_room_linking')}*/}
      {/*      </span>*/}
      {/*    </BBTab>*/}
      {/*    <BBTab*/}
      {/*      style={*/}
      {/*        status === IntegrationStatus.NotIntegrated || !someConnected*/}
      {/*          ? {*/}
      {/*              padding: '0px 15px',*/}
      {/*              paddingBottom: '12px',*/}
      {/*              wordBreak: 'break-word',*/}
      {/*              whiteSpace: 'pre-wrap',*/}
      {/*              color: '#bababa',*/}
      {/*              cursor: 'not-allowed',*/}
      {/*            }*/}
      {/*          : {*/}
      {/*              padding: '0px 15px',*/}
      {/*              whiteSpace: 'pre-wrap',*/}
      {/*              paddingBottom: '12px',*/}
      {/*              wordBreak: 'break-word',*/}
      {/*            }*/}
      {/*      }*/}
      {/*    >*/}
      {/*      <span style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>*/}
      {/*        {t('sync_menu')}*/}
      {/*      </span>*/}
      {/*    </BBTab>*/}
      {/*  </BBTabList>*/}
      {/*  <BBTabPanel desktop={true} mobile={mobile} size={size}>*/}
      {/*    <LoginAirbnb mobile={mobile} />*/}
      {/*  </BBTabPanel>*/}
      {/*  <BBTabPanel*/}
      {/*    desktop={true}*/}
      {/*    mobile={mobile}*/}
      {/*    size={size}*/}
      {/*    forceRender={true}*/}
      {/*  >*/}
      {/*    <ConnectListings unblock={unblock} mobile={mobile} />*/}
      {/*  </BBTabPanel>*/}
      {/*  <BBTabPanel*/}
      {/*    desktop={true}*/}
      {/*    mobile={mobile}*/}
      {/*    size={size}*/}
      {/*    forceRender={true}*/}
      {/*  >*/}
      {/*    <Synchronization*/}
      {/*      setDisableCheck={setDisableCheck}*/}
      {/*      ref={syncRef}*/}
      {/*      mobile={mobile}*/}
      {/*    />*/}
      {/*  </BBTabPanel>*/}
      {/*</BBTabs>*/}
    </div>
  )
}

export interface IIntegrationAirbnb {
  setDisableCheck: (value: boolean) => void
}

export default withRouter(IntegrationAirbnb)
